module.exports = __webpack_public_path__ + "img/circle-minus.ef59ff37.svg";